export const generateUUID = (): string => {
  return crypto.randomUUID();
};
